// IEModal action types

const ieModalActionTypes = {
  SET_IEMODAL_IS_ALREADY_SHOWN: 'SET_IEMODAL_IS_ALREADY_SHOWN'
};

export default ieModalActionTypes;
